export const featuredComics = [
  {
    id: 1,
    title: '洞洞杂货铺',
    author: '墨白',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20comic%20cover%20art%2C%20mysterious%20grocery%20store%20with%20magical%20items%20glowing%20on%20shelves%2C%20warm%20amber%20lighting%2C%20whimsical%20fantasy%20atmosphere%2C%20detailed%20illustration%20style%20with%20soft%20watercolor%20texture%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20manga%20cover%20quality&width=400&height=560&seq=comic-cover-dongdong-01&orientation=portrait',
    description: '一家隐藏在城市角落的神秘杂货铺，每个物品都有它自己的故事。店主洞爷用温暖和智慧帮助每一个走进店铺的人。',
    chapters: 186,
    views: '1280万',
    rating: 9.7,
    isNew: true,
    tags: ['热门', '推荐'],
  },
  {
    id: 2,
    title: '星海迷途',
    author: '林深',
    category: '科幻未来',
    categorySlug: 'scifi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manga%20cover%2C%20astronaut%20floating%20in%20colorful%20nebula%20space%2C%20distant%20galaxy%20and%20stars%2C%20cosmic%20dreamscape%20with%20ethereal%20blue%20and%20purple%20tones%2C%20clean%20illustration%20style%2C%20simple%20dark%20background%2C%20professional%20manga%20cover%20quality&width=400&height=560&seq=comic-cover-star-sea-02&orientation=portrait',
    chapters: 92,
    views: '650万',
    rating: 9.5,
    isNew: true,
    tags: ['新作', '科幻'],
  },
  {
    id: 3,
    title: '长安妖事录',
    author: '苏九',
    category: '古风仙侠',
    categorySlug: 'xianxia',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20fantasy%20manga%20cover%2C%20Tang%20Dynasty%20Changan%20cityscape%20at%20night%20with%20lanterns%2C%20mystical%20fox%20spirit%20in%20elegant%20hanfu%20robe%2C%20traditional%20Chinese%20architecture%2C%20warm%20golden%20and%20red%20color%20palette%2C%20clean%20simple%20background%20with%20soft%20focus%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-changan-03&orientation=portrait',
    chapters: 154,
    views: '960万',
    rating: 9.8,
    isNew: false,
    tags: ['经典', '仙侠'],
  },
  {
    id: 4,
    title: '雨夜追踪',
    author: '七月',
    category: '悬疑推理',
    categorySlug: 'mystery',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20thriller%20manga%20cover%2C%20rainy%20night%20street%20scene%20with%20neon%20reflections%2C%20detective%20silhouette%20under%20umbrella%2C%20noir%20atmosphere%20with%20dramatic%20lighting%2C%20modern%20urban%20setting%2C%20clean%20dark%20background%20with%20subtle%20rain%20texture%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-rain-04&orientation=portrait',
    chapters: 78,
    views: '430万',
    rating: 9.4,
    isNew: true,
    tags: ['悬疑', '新作'],
  },
  {
    id: 5,
    title: '吃货修仙记',
    author: '糖豆',
    category: '搞笑日常',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manga%20cover%2C%20cute%20girl%20enjoying%20delicious%20Chinese%20food%20in%20fantasy%20cultivation%20world%2C%20colorful%20dishes%20floating%20with%20magical%20energy%2C%20bright%20cheerful%20warm%20colors%2C%20playful%20illustration%20style%2C%20clean%20simple%20light%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-foodie-05&orientation=portrait',
    chapters: 210,
    views: '1520万',
    rating: 9.6,
    isNew: false,
    tags: ['热门', '搞笑'],
  },
  {
    id: 6,
    title: '倒数七日',
    author: '暗夜',
    category: '惊悚恐怖',
    categorySlug: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20manga%20cover%2C%20mysterious%20countdown%20clock%20in%20abandoned%20building%2C%20eerie%20atmosphere%20with%20cold%20blue%20tones%2C%20shadowy%20figure%20in%20background%2C%20psychological%20thriller%20vibe%2C%20clean%20dark%20simple%20background%2C%20professional%20manga%20cover%20quality&width=400&height=560&seq=comic-cover-countdown-06&orientation=portrait',
    chapters: 45,
    views: '380万',
    rating: 9.3,
    isNew: true,
    tags: ['惊悚', '短篇'],
  },
  {
    id: 7,
    title: '剑来山海',
    author: '墨白',
    category: '热血战斗',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20action%20manga%20cover%2C%20swordsman%20in%20dynamic%20battle%20pose%20with%20flowing%20robe%2C%20ancient%20Chinese%20mountain%20landscape%2C%20dramatic%20wind%20and%20energy%20effects%2C%20epic%20martial%20arts%20scene%2C%20clean%20simple%20background%20with%20mist%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-sword-07&orientation=portrait',
    chapters: 132,
    views: '870万',
    rating: 9.7,
    isNew: false,
    tags: ['热血', '推荐'],
  },
  {
    id: 8,
    title: '街角咖啡馆',
    author: '暖暖',
    category: '治愈日常',
    categorySlug: 'slice-of-life',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20slice%20of%20life%20manga%20cover%2C%20cozy%20corner%20cafe%20with%20warm%20sunlight%20streaming%20through%20window%2C%20barista%20making%20latte%20art%2C%20cats%20sleeping%20on%20wooden%20table%2C%20heartwarming%20atmosphere%2C%20soft%20pastel%20warm%20tones%2C%20clean%20simple%20background%2C%20professional%20manga%20cover&width=400&height=560&seq=comic-cover-cafe-08&orientation=portrait',
    chapters: 68,
    views: '290万',
    rating: 9.2,
    isNew: false,
    tags: ['治愈', '日常'],
  },
];

export const categories = [
  { name: '奇幻冒险', slug: 'fantasy', count: 326, icon: 'ri-magic-line' },
  { name: '古风仙侠', slug: 'xianxia', count: 258, icon: 'ri-cloud-line' },
  { name: '热血战斗', slug: 'action', count: 412, icon: 'ri-sword-line' },
  { name: '悬疑推理', slug: 'mystery', count: 187, icon: 'ri-search-eye-line' },
  { name: '科幻未来', slug: 'scifi', count: 145, icon: 'ri-rocket-line' },
  { name: '搞笑日常', slug: 'comedy', count: 298, icon: 'ri-emotion-laugh-line' },
  { name: '治愈日常', slug: 'slice-of-life', count: 203, icon: 'ri-heart-line' },
  { name: '惊悚恐怖', slug: 'horror', count: 96, icon: 'ri-ghost-line' },
  { name: '恋爱甜宠', slug: 'romance', count: 354, icon: 'ri-heart-pulse-line' },
  { name: '校园青春', slug: 'school', count: 267, icon: 'ri-book-open-line' },
];

export const editorPicks = [
  {
    id: 1,
    quote: '洞洞杂货铺是近年来少有的能把奇幻与现实结合得如此完美的作品。每个章节都像打开一个神秘的抽屉，你不知道里面装的是欢笑还是泪水，但每一次都让人意犹未尽。',
    editor: '林小树',
    title: '资深漫画编辑',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20in%20casual%20style%2C%20warm%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20beige%20background%2C%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-editor-01&orientation=squarish',
    comicTitle: '洞洞杂货铺',
  },
  {
    id: 2,
    quote: '长安妖事录的画面质感堪称艺术品，苏九老师用细腻的笔触为我们重现了一个妖异与诗意并存的大唐长安。这不仅仅是漫画，更是一幅幅流动的画卷。',
    editor: '苏子墨',
    title: '知名漫评人',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20art%20critic%20portrait%2C%20elegant%20and%20intellectual%20look%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20background%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-editor-02&orientation=squarish',
    comicTitle: '长安妖事录',
  },
  {
    id: 3,
    quote: '吃货修仙记证明了搞笑漫画同样可以有深度。糖豆老师对"吃"的描绘已经到了出神入化的地步，看这部漫画一定要备好零食，因为真的会看饿！',
    editor: '大鱼',
    title: '漫画专栏作家',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20writer%20portrait%2C%20creative%20and%20energetic%20expression%2C%20modern%20casual%20style%2C%20clean%20light%20background%2C%20professional%20portrait%20photography&width=200&height=200&seq=avatar-editor-03&orientation=squarish',
    comicTitle: '吃货修仙记',
  },
];

export const heroComics = [
  {
    id: 1,
    title: '洞洞杂货铺',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20cover%20art%2C%20magical%20grocery%20store%20interior%20with%20antique%20items%20and%20glowing%20magical%20artifacts%2C%20warm%20cozy%20atmosphere%2C%20whimsical%20fantasy%20illustration%2C%20detailed%20manga%20style%2C%20simple%20gradient%20background%2C%20professional%20comic%20cover&width=320&height=450&seq=hero-comic-dongdong-01&orientation=portrait',
    chapters: 186,
    rating: 9.7,
  },
  {
    id: 2,
    title: '长安妖事录',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20fantasy%20manga%20cover%2C%20elegant%20fox%20demon%20in%20red%20hanfu%20dress%20at%20ancient%20Chinese%20palace%2C%20moonlit%20night%20scene%2C%20traditional%20Chinese%20art%20style%20with%20modern%20manga%20touch%2C%20simple%20dark%20background%2C%20professional%20comic%20cover&width=320&height=450&seq=hero-comic-changan-02&orientation=portrait',
    chapters: 154,
    rating: 9.8,
  },
  {
    id: 3,
    title: '剑来山海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20cover%2C%20heroic%20swordsman%20with%20flowing%20black%20hair%20standing%20on%20mountain%20peak%2C%20epic%20sunrise%20sky%2C%20dramatic%20ink%20wash%20painting%20style%2C%20clean%20gradient%20background%2C%20professional%20comic%20cover&width=320&height=450&seq=hero-comic-sword-03&orientation=portrait',
    chapters: 132,
    rating: 9.7,
  },
];

export const siteInfo = {
  name: '布丁漫画网',
  tagline: '发现好漫画，从这里开始',
  description: '布丁漫画网是国内领先的正版漫画在线阅读平台，致力于为漫画爱好者提供高品质、无删减的漫画阅读体验。收录海量国产原创漫画，支持下拉式流畅阅读，全章节实时更新。',
  email: 'hello@591chaxin.cn',
  phone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T3 12层',
  socialLinks: {
    weibo: 'http://591chaxin.cn/',
    wechat: '#',
    bilibili: 'http://591chaxin.cn/',
    xiaohongshu: 'http://591chaxin.cn/',
  },
};

export const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/fantasy' },
  { name: '排行榜', path: '/category/action' },
  { name: '最新上架', path: '/category/scifi' },
  { name: '关于我们', path: '/about' },
];

export const latestUpdates = [
  { id: 1, title: '洞洞杂货铺', chapter: '第186话 最后的杂货', category: '奇幻冒险', time: '3分钟前', coverImage: featuredComics[0].coverImage },
  { id: 2, title: '长安妖事录', chapter: '第154话 月下逢', category: '古风仙侠', time: '15分钟前', coverImage: featuredComics[1].coverImage },
  { id: 3, title: '吃货修仙记', chapter: '第210话 满汉全席', category: '搞笑日常', time: '28分钟前', coverImage: featuredComics[4].coverImage },
  { id: 4, title: '剑来山海', chapter: '第132话 一剑开天', category: '热血战斗', time: '1小时前', coverImage: featuredComics[6].coverImage },
  { id: 5, title: '雨夜追踪', chapter: '第78话 真相', category: '悬疑推理', time: '2小时前', coverImage: featuredComics[3].coverImage },
  { id: 6, title: '星海迷途', chapter: '第92话 归途', category: '科幻未来', time: '3小时前', coverImage: featuredComics[1].coverImage },
];

export const hotComics = [
  { id: 1, title: '洞洞杂货铺', author: '墨白', views: '1280万', coverImage: featuredComics[0].coverImage },
  { id: 2, title: '吃货修仙记', author: '糖豆', views: '1520万', coverImage: featuredComics[4].coverImage },
  { id: 3, title: '长安妖事录', author: '苏九', views: '960万', coverImage: featuredComics[1].coverImage },
  { id: 4, title: '剑来山海', author: '墨白', views: '870万', coverImage: featuredComics[6].coverImage },
  { id: 5, title: '星海迷途', author: '林深', views: '650万', coverImage: featuredComics[1].coverImage },
];

export const aboutInfo = {
  brandStory: '布丁漫画网成立于2018年，由一群热爱漫画的年轻人创立。我们坚信每一部漫画都是一个独立的世界，承载着作者的梦想和读者的期待。六年来，我们始终坚持"正版、精品、无删减"的原则，为国内漫画爱好者打造了一个纯净、高品质的阅读社区。',
  milestones: [
    { year: '2018', event: '布丁漫画网正式上线，首批签约50位原创漫画作者' },
    { year: '2019', event: '平台注册用户突破100万，上线APP客户端' },
    { year: '2020', event: '推出"创作者扶持计划"，签约作者超过300位' },
    { year: '2021', event: '月活跃用户突破500万，累计漫画作品超2000部' },
    { year: '2022', event: '获评"年度最佳漫画阅读平台"，与多家出版社达成合作' },
    { year: '2023', event: '上线下拉式阅读模式，阅读体验全面升级' },
    { year: '2024', event: '注册用户突破2000万，成为国内Top 3漫画平台' },
  ],
  values: [
    { title: '正版授权', description: '所有漫画作品均获得作者或版权方正版授权，保障创作者权益' },
    { title: '无删减内容', description: '坚持呈现漫画原汁原味的完整内容，拒绝任何形式的删减修改' },
    { title: '流畅阅读', description: '采用先进的下拉式阅读技术和图片加载算法，确保流畅的阅读体验' },
    { title: '社区共建', description: '打造活跃的漫友社区，让读者与创作者直接交流互动' },
  ],
  teamImage: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20office%20team%20collaboration%2C%20young%20designers%20and%20editors%20working%20around%20large%20desk%20with%20comic%20art%20displayed%20on%20monitors%2C%20modern%20minimalist%20studio%20with%20warm%20lighting%2C%20manga%20posters%20on%20walls%2C%20clean%20bright%20atmosphere%2C%20professional%20photography%20style&width=800&height=500&seq=about-team-image-01&orientation=landscape',
  officeImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20tech%20company%20office%20interior%2C%20open%20workspace%20with%20comic%20art%20display%20walls%2C%20comfortable%20reading%20corner%20with%20bookshelves%20full%20of%20manga%2C%20bright%20natural%20light%20through%20large%20windows%2C%20creative%20and%20cozy%20atmosphere%2C%20professional%20architectural%20photography&width=800&height=500&seq=about-office-02&orientation=landscape',
};
